import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import useStyles from './gluOverride.styles';

const GluOverrideComponent = ({ children, className }) => {
  const { gluOverride } = useStyles();
  return <div className={classnames(gluOverride, className)}>{children}</div>;
};

GluOverrideComponent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
GluOverrideComponent.defaultProps = {
  children: [],
  className: ''
};

export default GluOverrideComponent;
